import React, { useEffect, useState } from 'react'
import CustomInput from 'Common/CustomInput/CustomInput'
import api from 'http';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader';

const CostShare = ({
    className = "",
    allPayers,
    costShareData,
    runEligibilityModel,
}) => {
    const [costShare, setCostShare] = useState({
        copay: "",
        deductible: "",
        coInsurance: "",
        outOfPocketMax: "",
    })
    const [initialCostShare, setInitialCostShare] = useState(null)
    const [loading, setLoading] = useState(false)
    const handleCostShareChange = (e) => {
        const { name, value } = e.target
        setCostShare(prev => ({
            ...prev,
            [name]: value
        }))
    }
    const handleSave = async () => {
        // Check if values have changed
        if (initialCostShare) {
            const hasChanged = 
                parseFloat(costShare.copay || 0) !== parseFloat(initialCostShare.copay || 0) ||
                parseFloat(costShare.deductible || 0) !== parseFloat(initialCostShare.deductible || 0) ||
                parseFloat(costShare.coInsurance || 0) !== parseFloat(initialCostShare.coInsurance || 0) ||
                parseFloat(costShare.outOfPocketMax || 0) !== parseFloat(initialCostShare.outOfPocketMax || 0)
            
            if (!hasChanged) {
                return // Don't call API if nothing changed
            }
        }

        try {
            setLoading(true)
            await api.post(`${process.env.REACT_APP_TC_PMS}/api/Patient/UpdatePatientInsuranceCostShare`, costShare)
            // Update initial values after successful save
            setInitialCostShare({ ...costShare })
        } catch (error) {
            ErrorHandlingMessage(error)
        } finally {
            setLoading(false)
        }
    }
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleSave()
        }
    }
    useEffect(() => {
        const model = allPayers?.find(item => item.payerId === runEligibilityModel.payerId)
        if (model){
            const newCostShare = { 
                ...costShareData, 
                id: model.patientPlanID, 
                patientId: runEligibilityModel.patientId
            }
            setCostShare(newCostShare)
            // Store initial values for comparison
            setInitialCostShare({
                copay: costShareData.copay ?? "",
                deductible: costShareData.deductible ?? "",
                coInsurance: costShareData.coInsurance ?? "",
                outOfPocketMax: costShareData.outOfPocketMax ?? "",
            })
        }
    }, [costShareData, runEligibilityModel.payerId, allPayers, runEligibilityModel.patientId])
    return (
        <div className={className}>
            {loading && <FullPageLoader allowFullScreen/>}
            <h1 className='text-lg font-semibold'>Cost Share</h1>
            <div className="grid grid-cols-12 gap-4 mt-2">
                <div className="col-span-12 md:col-span-3">
                    <CustomInput
                        name="copay"
                        data-nested="patientPlan.copay"
                        isNumeric
                        maxFloat={1}
                        onChange={handleCostShareChange}
                        onBlur={handleSave}
                        onKeyDown={handleKeyDown}
                        value={costShare.copay}
                        label="Copay"
                        isFloat
                        placeholder="0.00"
                        toolTip="Fixed amount paid for a covered service"
                        prefixIcon={<span className="text-gray-500 ">$</span>}
                        // disabled={loading}
                    />
                </div>
                <div className="col-span-12 md:col-span-3">
                    <CustomInput
                        name="deductible"
                        data-nested="patientPlan.deductible"
                        isNumeric
                        maxFloat={1}
                        onChange={handleCostShareChange}
                        onBlur={handleSave}
                        onKeyDown={handleKeyDown}
                        value={costShare.deductible}
                        label="Deductible"
                        isFloat
                        placeholder="0.00"
                        toolTip="Amount paid out of pocket before insurance begins to pay"
                        prefixIcon={<span className="text-gray-500 ">$</span>}
                        // disabled={loading}
                    />
                </div>
                <div className="col-span-12 md:col-span-3">
                    <CustomInput
                        name="coInsurance"
                        data-nested="patientPlan.coInsurance"
                        isNumeric
                        maxFloat={1}
                        onChange={handleCostShareChange}
                        onBlur={handleSave}
                        onKeyDown={handleKeyDown}
                        value={costShare.coInsurance}
                        label="Co-insurance"
                        isFloat
                        placeholder="0"
                        toolTip="Percentage of costs paid after deductible is met"
                        suffixIcon={<span className="pr-2 text-gray-500">%</span>}
                        // disabled={loading}
                    />
                </div>
                <div className="col-span-12 md:col-span-3">
                    <CustomInput
                        name="outOfPocketMax"
                        data-nested="patientPlan.outOfPocketMax"
                        isNumeric
                        maxFloat={1}
                        onChange={handleCostShareChange}
                        onBlur={handleSave}
                        onKeyDown={handleKeyDown}
                        value={costShare.outOfPocketMax}
                        label="Out Of Pocket Max"
                        isFloat
                        placeholder="0.00"
                        toolTip="Maximum amount you'll pay for covered services in a plan year"
                        prefixIcon={
                            <span className="font-medium text-gray-500">$</span>
                        }
                        // disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default CostShare

